export default __webpack_public_path__ + "static/digilock-new-york-city-ccc205ca0774d871f798e8e8a803effd.jpg";